import type { HomologationFacetStatus, HomologationStatus } from '@/types/catalog'

type HomologationGroup = 'ok' | 'nok' | 'der' | 'undefined'

interface HomologationStatusConfig {
  group: HomologationGroup
  status: HomologationStatus
  facetStatus: HomologationFacetStatus
  translationKey: string
}

export const HOMOLOGATION_STATUS_CONFIG = [
  { group: 'ok', status: 'OK', facetStatus: 'OK', translationKey: 'ok' },
  { group: 'nok', status: 'NOT OK', facetStatus: 'NOK', translationKey: 'nok' },
  { group: 'der', status: 'PENDING', facetStatus: 'DER', translationKey: 'der' },
  { group: 'undefined', status: 'UNVERIFIED', facetStatus: 'UNDEFINED', translationKey: 'undefined' },
] as const satisfies readonly HomologationStatusConfig[]

export function getHomologationStatusTranslationKey(status: HomologationStatus): string {
  return HOMOLOGATION_STATUS_CONFIG.find(config => config.status === status)?.translationKey ?? 'undefined'
}
